<div class="mu-tag" [ngStyle]="{ backgroundColor: getMuColor() }" (click)="filterAccountByMU()">
  {{ mu ? mu : 'MU Unassigned' }}
</div>
